module.exports = __webpack_public_path__ + "media/signup/crowdworks-3ffe4ffc.png";